<script setup lang="ts">
import { useDisplay } from 'vuetify'
import { useAuthStore } from '@/stores/auth'
import LogoWrapperImg from '@images/dashboard/logo-wrapper.png'
import { PagesWithVideo } from '@/interfaces/internal-resources/TutorialVideo'
import { TutorialVideoDialog, TutorialVideoBtn } from '@/components/app'

const authStore = useAuthStore()

const {
  organisationLogo,
  userProfile,
} = storeToRefs(authStore)

const { xs } = useDisplay()

const dialogRerenderKey = ref<number>(0)
const tutorialDialog = ref(false)

const onTutorialClick = () => {
  dialogRerenderKey.value++
  tutorialDialog.value = true
}
</script>

<template>
  <VCard class="mb-4 elevation-5 h-100 align-content-center organisation-logo-card">
    <VRow
      no-gutters
      class="h-100"
      align-content="center"
    >
      <VCol
        cols="12"
        sm="4"
        class="logo-white-wrapper"
      >
        <VImg
          :src="LogoWrapperImg"
          cover
          position="-10px 50%"
          class="h-100"
          :class="xs ? 'logo--sm' : ''"
        >
          <div class="h-100 align-center d-flex justify-center logo-white-circle">
            <VAvatar size="120">
              <VImg
                :src="organisationLogo?.src"
              />
            </VAvatar>
          </div>
        </VImg>
      </VCol>
      <VCol
        cols="12"
        sm="8"
        class="pa-4 d-flex flex-column justify-center"
      >
        <h3 class="mt-3 mb-2 text-white">
          {{ $t('pages.dashboard.logo_card_welcome', {name: userProfile?.first_name}) }}
        </h3>
        <p class="text-body-2 text-white">
          {{ $t('pages.dashboard.logo_card_congratulations') }}
        </p>

        <!-- Watch Tutorial btn -->
        <div class="text-right">
          <TutorialVideoBtn @on-click="onTutorialClick" />
          <TutorialVideoDialog
            :key="dialogRerenderKey"
            :page="PagesWithVideo.dashboard"
            :model="tutorialDialog"
          />
        </div>
      </VCol>
    </VRow>
  </VCard>
</template>

<style lang="scss">
@use "@sass/variables" as variables;

.organisation-logo-card {
  background-color: #365260;
}

.logo-white-wrapper {
  margin: -10px 0;
}

.logo--sm {
  max-height: 9rem;
}

.logo-white-circle {
  left: -17px;
  position: relative;
  .v-avatar {
    background-color: #ffffff;
    img {
      object-fit: contain !important;
    }
  }
}
</style>
